export default "__VITE_ASSET__BiEI1PHb__";